import { ISplitFlyers } from "./split-flyers.interface";
import { IFlyerDetailData } from "../flyer-detail-data/flyer-detail-data.interface";

export function createSplitFlyers(): ISplitFlyers {
  return {
    completedList: [],
    currentList: [],
  };
}

const addFlyerToSplitFlyers = (
  splitFlyers: ISplitFlyers,
  flyer: IFlyerDetailData
): ISplitFlyers => ({
  ...splitFlyers,
  ...(flyer.completed
    ? { completedList: [...splitFlyers.completedList, flyer] }
    : { currentList: [...splitFlyers.currentList, flyer] }),
});

export const splitFlyersByCreatedDate = (flyers: IFlyerDetailData[]): ISplitFlyers =>
  flyers.reduce(addFlyerToSplitFlyers, createSplitFlyers());
